import { AppBrowserTarget, openUrl as openUrlMobile, openFileViewer, isMobileApp } from "@/shared/mobileHelper";

export function getRoutePath (url: string) {
  try {
    const validUrl = new URL(url);
    let path = url.replace(validUrl.origin, "");
    path = path.replace("#/", "");
    return path;
  } catch (_) {
    return "";
  }
}

export function openUrl (url: string): void {
  url = url.toLowerCase().startsWith("http") ? url : `//${url}`;
  if (isMobileApp()) {
    openUrlMobile(url, AppBrowserTarget.system);
  } else {
    window.open(url, "_blank");
  }
}

export function openExternalUrl (url: string): void {
  if (isMobileApp()) {
    openFileViewer(url);
  } else {
    window.open(url, "_blank");
  }
}

export function linkClickHandler (event: Event) {
  if (event.currentTarget instanceof HTMLAnchorElement) {
    openUrl(event.currentTarget.href);
  }
}
